import { yupResolver } from '@hookform/resolvers/yup';
import { Box } from '@mui/material';
import PageHeaderText from 'layout/pages/PageHeaderText';
import PageHeaderWrapper from 'layout/pages/PageHeaderWrapper';
import { isNil } from 'lodash';
import { FormContainer, TextFieldElement, useForm } from 'react-hook-form-mui';
import { object, string } from 'yup';
import type { SubmitHandler } from 'react-hook-form-mui';

interface UsersFilterData {
  search: string;
}

export interface ClientsPageHeaderProps {
  searchTextInit?: string;
  onSearchChanged?: (text: string) => void;
}

export default function ClientsPageHeader({
  onSearchChanged,
  searchTextInit,
}: ClientsPageHeaderProps): JSX.Element {
  const schema = object<UsersFilterData>({
    search: string().max(300),
  }).required();

  const formContext = useForm<UsersFilterData>({
    mode: 'onChange',
    defaultValues: {
      search: searchTextInit ?? '',
    },
    resolver: yupResolver(schema),
  });

  const filter: SubmitHandler<UsersFilterData> = (data) => {
    !isNil(onSearchChanged) && onSearchChanged(data.search);
  };

  return (
    <PageHeaderWrapper>
      <PageHeaderText align='center' text='Клиенты' />
      <Box sx={{ '& form': { flexGrow: 1 } }} alignItems='center'>
        <FormContainer formContext={formContext} onSuccess={filter}>
          <TextFieldElement
            size='small'
            fullWidth
            name='search'
            placeholder='Поиск: ФИО, Телефон'
            type='search'
          />
        </FormContainer>
      </Box>
    </PageHeaderWrapper>
  );
}
